import Button from "./Button";

// Export without redux connection
export default Button;
